module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid grid-pad box-size",
    staticStyle: {
      "overflow": "initial"
    }
  }, [_c('div', {
    staticClass: "col-1-1 text-dark"
  }, [_c('div', {
    staticClass: "substitution"
  }, [_c('div', {
    staticClass: "header width-100"
  }, [_c('div', {
    staticClass: "flex space-between align-center"
  }, [_c('div', {
    staticClass: "substitution__header__left flex align-center"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.substitution.substitution')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeSubstitutionSettings),
      expression: "closeSubstitutionSettings"
    }],
    staticClass: "substitution__settings",
    class: {
      'substitution__settings--open': _vm.isSubstitutionSettingsOpen
    }
  }, [_c('button', {
    staticClass: "substitution__settings__toggle",
    attrs: {
      "type": "button",
      "aria-expanded": _vm.isSubstitutionSettingsOpen ? 'true' : 'false',
      "aria-label": _vm.$t('vue2.substitution.settings')
    },
    on: {
      "click": function($event) {
        _vm.isSubstitutionSettingsOpen = !_vm.isSubstitutionSettingsOpen
      }
    }
  }, [_c('span', {
    staticClass: "icon-more2"
  })]), _vm._v(" "), (_vm.isSubstitutionSettingsOpen) ? _c('div', {
    staticClass: "substitution__settings__dropdown"
  }, [_c('div', {
    staticClass: "substitution__settings__label"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.substitution.settings')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "substitution__settings__item",
    class: {
      'substitution__settings__item--active': _vm.includeReservationsInSubstitution
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleIncludeReservations
    }
  }, [_c('span', {
    staticClass: "substitution__settings__checkbox",
    class: {
      'substitution__settings__checkbox--checked': _vm.includeReservationsInSubstitution
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "substitution__settings__item-text"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('vue2.substitution.include_reservations')) + "\n                  ")])]), _vm._v(" "), _c('button', {
    staticClass: "substitution__settings__item",
    class: {
      'substitution__settings__item--active': _vm.showOverlappingClassBadgeInSubstitution
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleShowOverlappingClassBadge
    }
  }, [_c('span', {
    staticClass: "substitution__settings__checkbox",
    class: {
      'substitution__settings__checkbox--checked': _vm.showOverlappingClassBadgeInSubstitution
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "substitution__settings__item-text"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('vue2.substitution.show_overlapping_class_badge')) + "\n                  ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "substitution__header__right"
  }, [_c('SubsAbsentWithoutEnd'), _vm._v(" "), (_vm.userCanSeeInternalNote) ? _c('SubsNote', {
    attrs: {
      "date": _vm.getDate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isClassOnTripSchool) ? _c('button', {
    staticClass: "marg-10-right no-print aku-button",
    on: {
      "click": function($event) {
        return _vm.setIsModalClassOnTrip(true)
      }
    }
  }, [_vm._v("\n              Opret klassefravær\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.localSchedulerView) ? _c('button', {
    staticClass: "marg-10-right no-print",
    staticStyle: {
      "height": "38px",
      "width": "38px"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "date-buttons marg-5-right",
    class: {
      inactive: _vm.isToday
    },
    on: {
      "click": _vm.setToday
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.substitution.today')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "date-buttons marg-5-right",
    on: {
      "click": _vm.prevDay
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left4"
  })]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "date": _vm.getDate
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "marg-5-left date-buttons",
    on: {
      "click": _vm.nextDay
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right4"
  })]), _vm._v(" "), _c('SubstitutionCreate', {
    attrs: {
      "schoolId": _vm.schoolId,
      "users": _vm.allUsersSortedOnName,
      "usersWithOngoingAbsenceInHash": _vm.usersWithOngoingAbsenceInHash,
      "allUsersInCalIdHash": _vm.allUsersInCalIdHash
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sub-header__subHeader"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.absentTabs,
      "selected": _vm.currentAbsentTabId
    },
    on: {
      "select": _vm.onAbsentTabSelect
    }
  }), _vm._v(" "), _c('app-flipper-button', {
    attrs: {
      "preselectedTab": _vm.activeTab
    },
    on: {
      "update": _vm.setSchedulerView
    }
  })], 1), _vm._v(" "), ((_vm.isLoadingSchoolCalenders || _vm.dataIsLoading) && !_vm.localSchedulerView) ? _c('spinner', {
    staticStyle: {
      "margin-top": "150px"
    },
    attrs: {
      "color": "blue"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.localSchedulerView && !_vm.dataIsLoading && !_vm.isLoadingSchoolCalenders) ? _vm._l((_vm.absentUsers), function(user, idx) {
    return _c('SubsUser', {
      key: user.id,
      attrs: {
        "user": user,
        "activeDSelect": _vm.activeDSelect,
        "date": _vm.getDate,
        "allEvents": _vm.allEvents,
        "calsAndEventIds": _vm.calsAndEventIds,
        "allEventsInAHash": _vm.allEventsInAHash,
        "allUsersSortedOnName": _vm.allUsersSortedOnName,
        "allUsersAndEvents": _vm.allUsersAndEvents,
        "allCalendarsInAHash": _vm.allCalendarsInAHash,
        "longAbsentListInHash": _vm.longAbsentListInHash,
        "absentUsersHandledHash": _vm.absentUsersHandledHash,
        "isSubStatusPendingActive": _vm.isSubStatusPendingActive
      },
      on: {
        "splitLesson": _vm.setSplitLesson,
        "setActiveDSelect": _vm.setActiveDSelect,
        "selectedUser": function($event) {
          _vm.selectedUser = user
        },
        "removeSubs": _vm.setRemoveSubsFromEvent,
        "showLog": _vm.showEventLog
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.localSchedulerView) ? [_c('div', {
    staticClass: "sub-scheduler"
  }, [_c('div', {
    staticClass: "sub-scheduler__header"
  }, [_c('div', {
    staticClass: "sub-scheduler__header__left"
  }, [_c('div', {
    staticClass: "sub-scheduler__filters sub-scheduler__filters__subzen"
  }, [_c('SchedulerSort', {
    attrs: {
      "selected": _vm.selectedSort,
      "locale": _vm.locale,
      "groupTags": _vm.tags,
      "selectedGroupTags": _vm.priorityGroupTags
    },
    on: {
      "onSortBy": _vm.onSortBy,
      "toggleGroupTag": _vm.togglePriorityGroupTag,
      "clearAllGroupTags": _vm.clearAllPriorityGroupTags
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInLeft"
    }
  }, [(_vm.selectedSort === 'subzen') ? _c('scheduler-prioritizer', {
    attrs: {
      "propsIsPrioritizerActive": _vm.isPrioritizerActive
    },
    on: {
      "setIsPrioritizerActive": function($event) {
        _vm.isPrioritizerActive = $event
      }
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sub-scheduler__header__right sub-scheduler__header__right__filters"
  }, [(_vm.hasAbsentUsers) ? _c('Tabs', {
    attrs: {
      "flatDesign": true,
      "tabs": _vm.lessonViewTabs,
      "selected": _vm.selectedLessonViewTabId
    },
    on: {
      "select": _vm.onLessonViewTabSelect
    }
  }) : _vm._e(), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['in_the_class_this_day'],
      "tags": _vm.classTags,
      "selectedTags": _vm.selectedClassFilters
    },
    on: {
      "select": _vm.toggleClassFilter,
      "clear": _vm.clearAllClassFilters
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['absent'],
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFiltersAbsentUsers
    },
    on: {
      "select": _vm.toggleAbsentFilter,
      "clear": _vm.clearAllAbsentFilters
    }
  }), _vm._v(" "), _c('DoFilters', {
    attrs: {
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters,
      "selectedQuickFilters": _vm.selectedQuickFilters,
      "eventTitleTags": _vm.eventTitleTags,
      "selectedEventTitles": _vm.selectedEventTitleFilters,
      "isSortable": true,
      "sortItems": _vm.filterSortItems,
      "isSortActive": _vm.isFilterSortActive,
      "isPresenceOption": true,
      "groupsRequiringPresence": _vm.groupsRequiringPresence
    },
    on: {
      "select": _vm.toggleTag,
      "clear": _vm.clearAllTags,
      "toggleQuickFilter": function($event) {
        return _vm.toggleQuickFilter($event)
      },
      "clearAll": _vm.clearAllFiltersForSubs,
      "selectEventTitle": _vm.toggleEventTitleFilter,
      "clearEventTitles": _vm.clearAllEventTitleFilters,
      "sortItems": _vm.setFilterSortOrder,
      "toggleSort": _vm.setIsFilterSortActive,
      "togglePresenceGroup": _vm.togglePresenceGroup
    }
  })], 1)]), _vm._v(" "), _c('scheduler', {
    attrs: {
      "title": _vm.text,
      "subsTitle": _vm.subsHeadline,
      "items": _vm.absentAndSubs,
      "isSortOnName": _vm.sortOnName,
      "date": _vm.getDate,
      "isSubStatusPendingActive": _vm.isSubStatusPendingActive,
      "allCalendarsInHash": _vm.allCalendarsInAHash,
      "longAbsentListInHash": _vm.longAbsentListInHash,
      "isHideEventsNotOverlappingAbsence": _vm.isHideEventsNotOverlappingAbsence,
      "selectedEventTitleFilters": _vm.selectedEventTitleFilters,
      "selectedQuickFilters": _vm.selectedQuickFilters,
      "selectedClassFilters": _vm.selectedClassFilters,
      "selectedGroupFilters": _vm.appliedFilters
    },
    on: {
      "removeSubs": _vm.setRemoveSubsFromEvent,
      "showLog": _vm.showEventLog,
      "setCreateEventOnUser": _vm.setCreateEventOnUser,
      "splitLesson": _vm.setSplitLesson,
      "editTimes": _vm.setEditTimesLesson,
      "setTheOutOfSchoolLesson": function($event) {
        return _vm.setTheOutOfSchoolLesson($event)
      },
      "setIsCancelLesson": function($event) {
        return _vm.setIsCancelLesson($event)
      }
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.activeSplitLesson !== null) ? _c('splitLesson', {
    attrs: {
      "lesson": _vm.activeSplitLesson
    },
    on: {
      "submitted": _vm.onSubmittedSplitEvent,
      "closeSplitEvent": _vm.closeSplitLesson
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theEditTimesLesson) ? _c('SubsEventEditTimes', {
    attrs: {
      "lesson": _vm.theEditTimesLesson
    },
    on: {
      "updated": _vm.onEditTimesUpdated,
      "close": function($event) {
        return _vm.setEditTimesLesson(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModal) ? _c('AppModal', {
    attrs: {
      "submitTxt": _vm.i18n[_vm.locale]['button_text']
    },
    on: {
      "close": function($event) {
        _vm.isModal = false
      },
      "submit": _vm.removeSubs
    }
  }, [_c('h2', {
    staticClass: "pad-10",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['remove_subs']) + "\n      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['substitutes_for']))]), _vm._v(" "), _c('ul', {
    staticClass: "marg-20-top marg-20-bottom bold text-blue"
  }, _vm._l((_vm.userAndLessonAndSubsToBeDeleted.subsForTheSubToBeRemoved), function(sub) {
    return _c('li', {
      key: sub
    }, [_vm._v("\n            " + _vm._s(_vm.allUsersInCalIdHash[sub].name) + "\n          ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "marg-5-bottom"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['has_to_remove_subs']) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.i18n[_vm.locale]['click_on_remove_all']) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.eventChangesEvent) ? _c('AppModal', {
    attrs: {
      "submitTxt": "OK",
      "isShowFooter": false
    },
    on: {
      "close": function($event) {
        _vm.eventChangesEvent = null
      }
    }
  }, [_c('h2', {
    staticClass: "pad-10",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.eventChangesEvent.title))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('EventChanges', {
    attrs: {
      "event-id": _vm.eventChangesEvent.id
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), (_vm.activeAbsenceReason) ? _c('SubsEditAbsence') : _vm._e(), _vm._v(" "), (_vm.activeAbsentUser) ? _c('SubsUserPanel', {
    attrs: {
      "activeDate": _vm.getDate,
      "isSubStatusPendingActive": _vm.isSubStatusPendingActive
    },
    on: {
      "close": function($event) {
        return _vm.setActiveAbsentUser(null)
      },
      "readEvents": _vm.readEvents
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createEventOnUser && _vm.createEventOnUser.user) ? _c('CreateTask', {
    attrs: {
      "user": _vm.createEventOnUser.user,
      "initDate": _vm.createEventOnUser.date,
      "showSubstituteOption": true
    },
    on: {
      "close": function($event) {
        _vm.setCreateEventOnUser(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalClassOnTrip) ? _c('ClassOnTrip', {
    attrs: {
      "initDate": _vm.getDate
    },
    on: {
      "onCreatedEvents": _vm.readEvents,
      "close": function($event) {
        return _vm.setIsModalClassOnTrip(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theOutOfSchoolLesson) ? _c('DModalOutOfSchoolLesson', {
    attrs: {
      "event": _vm.theOutOfSchoolLesson,
      "eventIdProp": 'id'
    },
    on: {
      "updated": _vm.onOutOfSchoolLessonUpdated,
      "close": function($event) {
        return _vm.setTheOutOfSchoolLesson(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theCancelLesson) ? _c('DModalCancelLesson', {
    attrs: {
      "event": _vm.theCancelLesson,
      "eventIdProp": 'id'
    },
    on: {
      "updated": _vm.onCancelLessonUpdated,
      "close": function($event) {
        return _vm.setIsCancelLesson(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.schoolHasFeatureSMS) ? _c('SendMessages') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28f80768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/Subs.vue
// module id = 1819
// module chunks = 1